var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgWindow = function SvgWindow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,12.0766621 L0,60 L8.40280387,60 C8.40280387,60 17.1467865,59.436736 23.2287759,52.6771136 C29.4762525,45.726631 29.4210162,44.1718043 30.5430465,38.1449475 C31.851638,31.1603829 30.5430465,12.0766621 30.5430465,12.0766621 L69.4895627,12.0766621 C69.4895627,12.0766621 68.1911753,31.1606103 69.4895627,38.1449475 C70.6113707,44.1718043 70.5568,45.726631 76.8036113,52.6771136 C82.8749527,59.4362817 91.6191573,60 91.6191573,60 L100,60 L100,12.0766621 L100,0 L0,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51606843,67 L0,67 L0,87 L20,87 L20,76.1172293 C20,76.1172293 19.290823,72.95117 15.2086844,70.0559693 C11.2215899,67.2379853 5.51606843,67 5.51606843,67 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1269147,70.0559953 C81.4609105,72.9512213 81,76.117136 81,76.117136 L81,87 L94,87 L94,67 L90.4320252,67 C90.4320252,67 86.7104138,67.2379873 84.1269147,70.0559953 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgWindow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "window.97ddc0c74319d42044fa09eb5c9ebd4c.svg";